import { render, staticRenderFns } from "./NVPair.vue?vue&type=template&id=06c2d0bd"
import script from "./NVPair.vue?vue&type=script&lang=js"
export * from "./NVPair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/disk1/buildAgent/work/ffa2b6072150c7f8/vAnalyticsJS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06c2d0bd')) {
      api.createRecord('06c2d0bd', component.options)
    } else {
      api.reload('06c2d0bd', component.options)
    }
    module.hot.accept("./NVPair.vue?vue&type=template&id=06c2d0bd", function () {
      api.rerender('06c2d0bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/modules/admin/components/Common/NVPair.vue"
export default component.exports